import styled from 'styled-components';

// ToggleStyledComponents
export const ToggleContainer = styled.div`
  width: 58px;
  height: 30px;
  border-radius: 15px;
  display: flex;
  align-items: center;
  padding: 0 5px;
  cursor: pointer;
  transition: all 0.3s ease;
  background-color: ${props => props.isPoliticalCampaign ? '#C0392B' : '#2196F3'};
  position: relative;
`;

export const ToggleCircle = styled.div`
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background-color: white;
  transition: all 0.3s ease;
  position: absolute;
  left: ${props => props.isPoliticalCampaign ? '30px' : '2px'};
`;

export const CustomAcknowledgeParentContainer = styled.div`
padding: 20px;
border: 1px solid #d0d0d0;
border-radius: 6px;
max-height: 280px;
background-color: #fafafa;


@media (max-width: 1024px) {
    padding: 14px;
  }
  @media (max-width: 600px) {
    padding: 10px;
  }
`;

export const CustomAcknowledgeContainer = styled.div`
  max-height: 260px;
  overflow-y: scroll; /* Force scroll */
  padding-right: 8px;

  /* Apply mask only to content, not scrollbar */
  mask-image: ${props => props.showFade ? 'linear-gradient(to bottom, black 75%, transparent 95%)' : 'none'};
  -webkit-mask-image: ${props => props.showFade ? 'linear-gradient(to bottom, black 75%, transparent 95%)' : 'none'};
  
  /* Scrollbar styling */
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.3);
    border-radius: 3px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: rgba(0, 0, 0, 0.6);
  }
    
  @media (max-width: 1024px) {
    max-height: 120px;
    ::-webkit-scrollbar { width: 3px; }
  }
  @media (max-width: 600px) {
    max-height: 130px;
    ::-webkit-scrollbar { width: 4px; }
  }
`;



// Acknowledge ModalStyledComponents
export const CustomAcknowledgeTitle = styled.h2`
  color: ${props => props.type === 'Political' ? '#C0392B' : '#2196F3'};
  background-color: ${props => props.type === 'Political' ? 'rgba(244, 67, 54, 0.1)' : 'rgba(33, 150, 243, 0.1)'};
  padding: 12px;
  border-radius: 6px;
  margin-bottom: 15px;
  text-transform: uppercase;
  display:flex;
  align-items: center;
  font-size: 1.0rem;
  @media (max-width: 1024px) {
    font-size: 1.25rem;
  }
  @media (max-width: 600px) {
    font-size: 0.8rem;
  }
`;

export const CustomAcknowledgeDescription = styled.p`
  margin-bottom: 15px;
  line-height: 1.6;
  font-size: 1rem;
  @media (max-width: 1024px) {
    font-size: 0.9rem;
  }
  @media (max-width: 600px) {
    font-size: 0.8rem;
  }
`;

export const CustomAcknowledgeItemsList = styled.ol`
  margin: 15px 0;
  padding-left: 0;
  list-style: none;

  li {
    display: flex;
    gap: 12px;
    margin-bottom: 12px;
    line-height: 1.6;
    font-size: 1rem;
    @media (max-width: 1024px) {
      font-size: 0.9rem;
    }
    @media (max-width: 600px) {
      font-size: 0.8rem;
    }
  }
`;

export const CustomAcknowledgeItemNumber = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 25px;
  height: 24px;
  min-width: 25px;
  border-radius: 50%;
  background-color: ${props => props.type === 'Political' ? '#C0392B' : '#2196F3'};
  color: white;
  font-weight: bold;
  font-size: 14px;
  @media (max-width: 1024px) {
    width: 28px;
    height: 28px;
    min-width: 28px;
    font-size: 12px;
  }
  @media (max-width: 600px) {
    width: 24px;
    height: 24px;
    min-width: 24px;
    font-size: 10px;
  }
`;

// validation message styled box

export const ValidationMessageBox = styled.div`
  background-color: ${props => {
    const colors = {
      red: '#FFEBEE',
      green: '#E8F5E9',
      blue: '#E3F2FD',
      grey: '#f1f1f1ff',
    };
    return colors[props.variant] || colors.red;
  }};
  
  color: ${props => {
    const colors = {
      red: '#9c001f',
      green: '#1B5E20',
      blue: '#1565C0',
      grey: "#3e3e3eff"
    };
    return colors[props.variant] || colors.red;
  }};
  
  border: 1px solid ${props => {
    const colors = {
      red: '#9c001f',
      green: '#12a31bff',
      blue: '#1565C0',
      grey: "#e5e5e5ff"
    };
    return colors[props.variant] || colors.red;
  }};
  
  margin-top: 16px;
  font-size: 14px;
  border-radius: 6px;
  padding: 8px;
  display: flex;
  justify-content:start;
  align-items: start;
  gap: 5px;
`;

// Custom tabs for single and multiple days campaign and local and federal campaign
export const TabsWrapper = styled.div`
  overflow-x: auto;

  ul {
    display: flex;
    list-style: none;
    margin: 0;
    padding: 0;
    border-bottom: 1px solid #dbdbdb;

    @media (max-width: 768px) {
      flex-direction: column;
    }
  }

  li {
    cursor: pointer;
    border-radius: 12px 12px 12px 12px;
    transition: background-color 0.2s ease;

      @media (max-width: 768px) {
      flex: 1 1 100%;
      width: 100%;
    }

    &.active {
      background-color: #f0f0f0;
    }

    &:hover:not(.active) {
      text-decoration: underline;
    }

    a {
      display: inline-block;
      padding: 6px 12px;
      color: #363636;
      text-decoration: none;
    }
  }
`;

// Custom Section for quiet hours
export const QuietHoursSectionWrapper = styled.div`
  display: flex;
  width: fit-content;
  border: 1px solid #dbdbdb;
  border-radius: 12px;
  overflow: hidden; /* clips inner corners so only the outer edges look rounded */

@media (max-width: 768px) {
  flex-wrap: wrap;
  width: 100%;
}
`;

export const QuietHoursSection = styled.div`
 
  padding: 8px 28px;
  text-align: center;
  background-color: #fafafa;

  @media (max-width: 768px) {
    flex: 1 1 45%;
  }
  &:not(:last-child) {
    border-right: 1px solid #dbdbdb; /* the divider line between sections */
  }

  p {
    font-size: 14px;
    font-weight: bold;

     @media (max-width: 768px) {
      font-size: 12px;
    }
  }
`;

export const AcknowledgementRow = styled.div`
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start !important;
    gap: 8px;
  }
`;

export const IconWrapper = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: #FEF3C7; /* light yellow */
  display: flex;
  align-items: center;
  justify-content: center;
`;
